import React from "react";
import { connect } from "react-redux";
import "./reportView.css";
import { Redirect } from "react-router-dom";
import { routes } from "../../../routing/routes";

class ReportView extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const { location } = this.props;
    // TODO:- Change to distance report route for deploying Distance report
    const redirectRoute = routes.REPORTS_MODULE;
    return (
      <div className="pageContainer">
        <Redirect
          to={{
            pathname: redirectRoute,
            state: { from: location },
          }}
        />
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    selectedReports: state.ReportsType.selectedReportsType,
  };
}

export default connect(mapStateToProps, null)(ReportView);
